<script setup>
const props = defineProps({
    page: {
        type: Object,
        required: true
    }
})
</script>

<template>
    <div class="page-wrapper" :class="{ 'hide-header-footer': page.data?.hideHeaderFooter }" :data-model="page.model" :key="page.id">    
        <GlobalHeader v-if="!page.data?.hideHeaderFooter" />
        <div class="root-container">
            <main id="main" key="page" class="mess-page" tabindex="-1">
                <slot />
            </main>
        </div>
        <slot name="footer" />
        <GlobalFooter :pageTitle="page.data.title" :page="page"  v-if="!page.data?.hideHeaderFooter"  />
    </div>
</template>

<style lang="scss">

html.locked {
    overflow: hidden;
}

.page-wrapper {
    display: flex;
    min-height: 100vh;
    min-height: 100dvh;
    flex-direction: column;

    &.hide-header-footer {
        --header-height: 1rem;
    }
}

.layout-wrapper {
    display: flex;
    min-height: 100vh;
    min-height: 100dvh;
    flex-direction: column;
}

.locked .layout-wrapper {
    overflow: hidden;
}

.page-wrapper .root-container {
    flex: 1;
}

</style>
